import type { Invoice } from '@/api/orders';
import { SourceEmailLink } from '../SourceEmailLink';
import { SOURCE_KIND_LABEL } from './sourceKinds';

/** The emails an invoice was read from, as chips — every contributing source, once. */
export function InvoiceSourceChips({ inv, journeyId }: { inv: Invoice; journeyId: string }) {
  const chips: Array<{ key: string; messageId: string; label: string }> = [];
  const seen = new Set<string>();
  if (inv.sourceMessageId) {
    seen.add(inv.sourceMessageId);
    chips.push({ key: `p${inv.id}`, messageId: inv.sourceMessageId, label: 'invoice email' });
  }
  for (const s of inv.sources) {
    if (!s.messageId || seen.has(s.messageId)) continue;
    seen.add(s.messageId);
    chips.push({ key: s.id, messageId: s.messageId, label: SOURCE_KIND_LABEL[s.docKind] || s.docKind });
  }
  if (chips.length === 0) return null;
  return (
    <>
      {chips.map((c) => (
        <SourceEmailLink key={c.key} messageId={c.messageId} journeyId={journeyId} label={c.label} />
      ))}
    </>
  );
}
